import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import permission from './permission'
import user from './user'
import temp from './temp'
import result from './result'
import message from './message'
import setting from './setting'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    permission,
    user,
    temp,
    result,
    message,
    setting,
  },
})
